(function(){

  'use strict';

    // **********************************
    //  Data that this directive needs
    // ----------------------------------
    // 
    //

  function pxPrinterInput(
    Utils, $http, toastr, $filter, $timeout
  ) {
    return {
      restrict: 'EA',
      scope: {
        context: '=context',
        tenant: '=tenant',
        meta: '=meta',
        callback: '&callback'
      },
      templateUrl: 'app/components/printerProperties/printerSettings/printerInput/printerInput.template.html',
      link: function(scope) {

        scope.privatePrinter = angular.copy(scope.context.printer.info);
        scope.focus = false;
        scope.saveDisabled = true;

        $timeout(function () {
          scope.focus = true;
        }, 300)

        scope.checkInput = function () {
          var inputValue = scope.privatePrinter[scope.context.attributeKey]
          if (!inputValue || inputValue.length === 0) {
            scope.saveDisabled = true;
          } else {
            if (inputValue === scope.context.printer.info[scope.context.attributeKey]) {
              scope.saveDisabled = true;
            } else {
              scope.saveDisabled = false;
            }
          }
        }


        scope.saveSettings = function () {

          var patch = Utils.getObjectsDifferencesForPatching(scope.context.printer.info, scope.privatePrinter);

          var url = scope.context.printer.info._links.self.href;

          $http.patch(url, patch).then(function(response) {
            toastr.success($filter('translate')('ChangesSaved'))
          }).catch(function(error) {
            toastr.error($filter('translate')('ERROR'))
          });

          scope.callback();
        }

        scope.copyInputValue = function (wrapper) {
          var input = document.createElement('input');
          input.setAttribute('value', wrapper);
          document.body.appendChild(input);
          input.select();
          document.execCommand('copy');
          document.body.removeChild(input)
          toastr.success($filter("translate")("CopyToClipboard"));
        }






      }
    };
  }

  pxPrinterInput.$inject = ['Utils', '$http', 'toastr', '$filter', '$timeout'];

  angular
    .module('printix-admin')
    .directive('pxPrinterInput', pxPrinterInput);

})();
